/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject } from '@src/app/model/abstract-object';

/**
 * How much AI an organisation has switched on - the ids and the order match App\Models\AiLevel on
 * the server, which is where the rules live. Set on an agency it is the default for every OMC it
 * acts for; an OMC can set its own to override it.
 */
export const AI_LEVEL_NONE = 'none';
export const AI_LEVEL_REVIEW = 'review';
export const AI_LEVEL_TRIAGE = 'triage';

export const AI_LEVEL_HINT = $localize`None = no AI functions. Review = no AI responses are sent automatically;
    users are offered AI responses to accept, change or reject. Triage = AI classifications are applied
    and first responses sent automatically on newly created requests.`;

export const AI_LEVELS: AbstractObject[] = [
    {
        id: AI_LEVEL_NONE,
        name: $localize`None - no AI`,
        notes: $localize`Nothing about your requests is sent to an AI assistant.`,
    },
    {
        id: AI_LEVEL_REVIEW,
        name: $localize`Review - your team sends the answer`,
        notes: $localize`The assistant drafts an answer to a new request and offers it to your team,
            who send, change or reject it. Nothing reaches the person who raised the request unreviewed.`,
    },
    {
        id: AI_LEVEL_TRIAGE,
        name: $localize`First Triage - the assistant answers straight away`,
        notes: $localize`The assistant answers a request as it arrives, classifying it and replying to
            the person who raised it without waiting for anyone. Review stays available for everything else.`,
    },
];
